import { Injectable } from '@angular/core';
import { IDatiqAction, IDatiqRulesData, IqRulesService } from '@dat/iq-proxy';
import { first } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class IqWorkflowStateActionService {
    private _actions: Record<string, (payload: IDatiqAction) => void> = {};

    constructor(private readonly _rules: IqRulesService) {}

    fireActions(actions: IDatiqAction[]): void {
        actions.forEach((action: IDatiqAction) => {
            this.dispatch(action.name, action.payload);
        });
    }

    registerMap(actionMap: Record<string, (payload: any) => void>): void {
        Object.keys(actionMap).forEach((action: string) => {
            this.register(`${action}`, actionMap[action]);
        });
    }

    register(action: string, handler: (payload: any) => void): void {
        this._actions[action] = handler;
    }

    registerAll(
        actionHandlers: { action: string; handler: (payload: any) => void }[],
    ): void {
        actionHandlers.forEach(({ action, handler }) => {
            this.register(action, handler);
        });
    }

    unregister(action: string): void {
        delete this._actions[action];
    }

    dispatch(action: string, payload: any): void {
        if (this._actions[action]) {
            this._actions[action](payload);
        }
    }

    fireValidActions(rules: IDatiqRulesData<IDatiqAction>[]) {
        // .pipe(first()) is used to avoid duplicated actions being called and causing bugs.
        this._rules
            .evaluateRules$(rules)
            .pipe(first())
            .subscribe((actions) => {
                this.fireActions(actions);
            });
    }
}
